const compatModules = {};import * as Mod1 from "./discourse/adapters/anniversary";
compatModules["discourse/adapters/anniversary"] = Mod1;

export * as discourse$adapters$anniversary$$__module from "./discourse/adapters/anniversary";
export {
default as discourse$adapters$anniversary$$default
} from "./discourse/adapters/anniversary";
import * as Mod2 from "./discourse/adapters/birthday";
compatModules["discourse/adapters/birthday"] = Mod2;

export * as discourse$adapters$birthday$$__module from "./discourse/adapters/birthday";
export {
default as discourse$adapters$birthday$$default
} from "./discourse/adapters/birthday";
import * as Mod3 from "./discourse/adapters/cakeday";
compatModules["discourse/adapters/cakeday"] = Mod3;

export * as discourse$adapters$cakeday$$__module from "./discourse/adapters/cakeday";
export {
default as discourse$adapters$cakeday$$default
} from "./discourse/adapters/cakeday";
import * as Mod4 from "./discourse/components/emoji-images";
compatModules["discourse/components/emoji-images"] = Mod4;

export * as discourse$components$emoji__images$$__module from "./discourse/components/emoji-images";
export {
default as discourse$components$emoji__images$$default
} from "./discourse/components/emoji-images";
import * as Mod5 from "./discourse/components/user-info-list";
compatModules["discourse/components/user-info-list"] = Mod5;

export * as discourse$components$user__info__list$$__module from "./discourse/components/user-info-list";
export {
default as discourse$components$user__info__list$$default
} from "./discourse/components/user-info-list";
import * as Mod6 from "./discourse/connectors/user-card-post-names/user-card-cakeday.gjs";
compatModules["discourse/connectors/user-card-post-names/user-card-cakeday"] = Mod6;

export * as discourse$connectors$user__card__post__names$user__card__cakeday$$__module from "./discourse/connectors/user-card-post-names/user-card-cakeday.gjs";
export {
default as discourse$connectors$user__card__post__names$user__card__cakeday$$default
} from "./discourse/connectors/user-card-post-names/user-card-cakeday.gjs";
import * as Mod7 from "./discourse/connectors/user-custom-preferences/user-date-of-birth-input.gjs";
compatModules["discourse/connectors/user-custom-preferences/user-date-of-birth-input"] = Mod7;

export * as discourse$connectors$user__custom__preferences$user__date__of__birth__input$$__module from "./discourse/connectors/user-custom-preferences/user-date-of-birth-input.gjs";
export {
default as discourse$connectors$user__custom__preferences$user__date__of__birth__input$$default
} from "./discourse/connectors/user-custom-preferences/user-date-of-birth-input.gjs";
import * as Mod8 from "./discourse/connectors/user-post-names/user-cakeday.gjs";
compatModules["discourse/connectors/user-post-names/user-cakeday"] = Mod8;

export * as discourse$connectors$user__post__names$user__cakeday$$__module from "./discourse/connectors/user-post-names/user-cakeday.gjs";
export {
default as discourse$connectors$user__post__names$user__cakeday$$default
} from "./discourse/connectors/user-post-names/user-cakeday.gjs";
import * as Mod9 from "./discourse/controllers/cakeday";
compatModules["discourse/controllers/cakeday"] = Mod9;

export * as discourse$controllers$cakeday$$__module from "./discourse/controllers/cakeday";
export {
default as discourse$controllers$cakeday$$default
} from "./discourse/controllers/cakeday";
import * as Mod10 from "./discourse/controllers/cakeday/anniversaries/all";
compatModules["discourse/controllers/cakeday/anniversaries/all"] = Mod10;

export * as discourse$controllers$cakeday$anniversaries$all$$__module from "./discourse/controllers/cakeday/anniversaries/all";
export {
default as discourse$controllers$cakeday$anniversaries$all$$default
} from "./discourse/controllers/cakeday/anniversaries/all";
import * as Mod11 from "./discourse/controllers/cakeday/anniversaries/today";
compatModules["discourse/controllers/cakeday/anniversaries/today"] = Mod11;

export * as discourse$controllers$cakeday$anniversaries$today$$__module from "./discourse/controllers/cakeday/anniversaries/today";
export {
default as discourse$controllers$cakeday$anniversaries$today$$default
} from "./discourse/controllers/cakeday/anniversaries/today";
import * as Mod12 from "./discourse/controllers/cakeday/anniversaries/tomorrow";
compatModules["discourse/controllers/cakeday/anniversaries/tomorrow"] = Mod12;

export * as discourse$controllers$cakeday$anniversaries$tomorrow$$__module from "./discourse/controllers/cakeday/anniversaries/tomorrow";
export {
default as discourse$controllers$cakeday$anniversaries$tomorrow$$default
} from "./discourse/controllers/cakeday/anniversaries/tomorrow";
import * as Mod13 from "./discourse/controllers/cakeday/anniversaries/upcoming";
compatModules["discourse/controllers/cakeday/anniversaries/upcoming"] = Mod13;

export * as discourse$controllers$cakeday$anniversaries$upcoming$$__module from "./discourse/controllers/cakeday/anniversaries/upcoming";
export {
default as discourse$controllers$cakeday$anniversaries$upcoming$$default
} from "./discourse/controllers/cakeday/anniversaries/upcoming";
import * as Mod14 from "./discourse/controllers/cakeday/birthdays/all";
compatModules["discourse/controllers/cakeday/birthdays/all"] = Mod14;

export * as discourse$controllers$cakeday$birthdays$all$$__module from "./discourse/controllers/cakeday/birthdays/all";
export {
default as discourse$controllers$cakeday$birthdays$all$$default
} from "./discourse/controllers/cakeday/birthdays/all";
import * as Mod15 from "./discourse/controllers/cakeday/birthdays/today";
compatModules["discourse/controllers/cakeday/birthdays/today"] = Mod15;

export * as discourse$controllers$cakeday$birthdays$today$$__module from "./discourse/controllers/cakeday/birthdays/today";
export {
default as discourse$controllers$cakeday$birthdays$today$$default
} from "./discourse/controllers/cakeday/birthdays/today";
import * as Mod16 from "./discourse/controllers/cakeday/birthdays/tomorrow";
compatModules["discourse/controllers/cakeday/birthdays/tomorrow"] = Mod16;

export * as discourse$controllers$cakeday$birthdays$tomorrow$$__module from "./discourse/controllers/cakeday/birthdays/tomorrow";
export {
default as discourse$controllers$cakeday$birthdays$tomorrow$$default
} from "./discourse/controllers/cakeday/birthdays/tomorrow";
import * as Mod17 from "./discourse/controllers/cakeday/birthdays/upcoming";
compatModules["discourse/controllers/cakeday/birthdays/upcoming"] = Mod17;

export * as discourse$controllers$cakeday$birthdays$upcoming$$__module from "./discourse/controllers/cakeday/birthdays/upcoming";
export {
default as discourse$controllers$cakeday$birthdays$upcoming$$default
} from "./discourse/controllers/cakeday/birthdays/upcoming";
import * as Mod18 from "./discourse/discourse-cakeday-route-map";
compatModules["discourse/discourse-cakeday-route-map"] = Mod18;

export * as discourse$discourse__cakeday__route__map$$__module from "./discourse/discourse-cakeday-route-map";
export {
default as discourse$discourse__cakeday__route__map$$default
} from "./discourse/discourse-cakeday-route-map";
import * as Mod19 from "./discourse/initializers/cakeday-admin-plugin-configuration-nav";
compatModules["discourse/initializers/cakeday-admin-plugin-configuration-nav"] = Mod19;

export * as discourse$initializers$cakeday__admin__plugin__configuration__nav$$__module from "./discourse/initializers/cakeday-admin-plugin-configuration-nav";
export {
default as discourse$initializers$cakeday__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/cakeday-admin-plugin-configuration-nav";
import * as Mod20 from "./discourse/initializers/cakeday";
compatModules["discourse/initializers/cakeday"] = Mod20;

export * as discourse$initializers$cakeday$$__module from "./discourse/initializers/cakeday";
export {
default as discourse$initializers$cakeday$$default
} from "./discourse/initializers/cakeday";
import * as Mod21 from "./discourse/lib/cakeday";
compatModules["discourse/lib/cakeday"] = Mod21;

export * as discourse$lib$cakeday$$__module from "./discourse/lib/cakeday";
export {
cakeday as discourse$lib$cakeday$$cakeday,
birthday as discourse$lib$cakeday$$birthday,
cakedayTitle as discourse$lib$cakeday$$cakedayTitle,
birthdayTitle as discourse$lib$cakeday$$birthdayTitle
} from "./discourse/lib/cakeday";
import * as Mod22 from "./discourse/routes/build-cakeday-route";
compatModules["discourse/routes/build-cakeday-route"] = Mod22;

export * as discourse$routes$build__cakeday__route$$__module from "./discourse/routes/build-cakeday-route";
export {
default as discourse$routes$build__cakeday__route$$default
} from "./discourse/routes/build-cakeday-route";
import * as Mod23 from "./discourse/routes/cakeday/anniversaries";
compatModules["discourse/routes/cakeday/anniversaries"] = Mod23;

export * as discourse$routes$cakeday$anniversaries$$__module from "./discourse/routes/cakeday/anniversaries";
export {
default as discourse$routes$cakeday$anniversaries$$default
} from "./discourse/routes/cakeday/anniversaries";
import * as Mod24 from "./discourse/routes/cakeday/anniversaries/all";
compatModules["discourse/routes/cakeday/anniversaries/all"] = Mod24;

export * as discourse$routes$cakeday$anniversaries$all$$__module from "./discourse/routes/cakeday/anniversaries/all";
export {
default as discourse$routes$cakeday$anniversaries$all$$default
} from "./discourse/routes/cakeday/anniversaries/all";
import * as Mod25 from "./discourse/routes/cakeday/anniversaries/index";
compatModules["discourse/routes/cakeday/anniversaries/index"] = Mod25;

export * as discourse$routes$cakeday$anniversaries$index$$__module from "./discourse/routes/cakeday/anniversaries/index";
export {
default as discourse$routes$cakeday$anniversaries$index$$default
} from "./discourse/routes/cakeday/anniversaries/index";
import * as Mod26 from "./discourse/routes/cakeday/anniversaries/today";
compatModules["discourse/routes/cakeday/anniversaries/today"] = Mod26;

export * as discourse$routes$cakeday$anniversaries$today$$__module from "./discourse/routes/cakeday/anniversaries/today";
export {
default as discourse$routes$cakeday$anniversaries$today$$default
} from "./discourse/routes/cakeday/anniversaries/today";
import * as Mod27 from "./discourse/routes/cakeday/anniversaries/tomorrow";
compatModules["discourse/routes/cakeday/anniversaries/tomorrow"] = Mod27;

export * as discourse$routes$cakeday$anniversaries$tomorrow$$__module from "./discourse/routes/cakeday/anniversaries/tomorrow";
export {
default as discourse$routes$cakeday$anniversaries$tomorrow$$default
} from "./discourse/routes/cakeday/anniversaries/tomorrow";
import * as Mod28 from "./discourse/routes/cakeday/anniversaries/upcoming";
compatModules["discourse/routes/cakeday/anniversaries/upcoming"] = Mod28;

export * as discourse$routes$cakeday$anniversaries$upcoming$$__module from "./discourse/routes/cakeday/anniversaries/upcoming";
export {
default as discourse$routes$cakeday$anniversaries$upcoming$$default
} from "./discourse/routes/cakeday/anniversaries/upcoming";
import * as Mod29 from "./discourse/routes/cakeday/birthdays";
compatModules["discourse/routes/cakeday/birthdays"] = Mod29;

export * as discourse$routes$cakeday$birthdays$$__module from "./discourse/routes/cakeday/birthdays";
export {
default as discourse$routes$cakeday$birthdays$$default
} from "./discourse/routes/cakeday/birthdays";
import * as Mod30 from "./discourse/routes/cakeday/birthdays/all";
compatModules["discourse/routes/cakeday/birthdays/all"] = Mod30;

export * as discourse$routes$cakeday$birthdays$all$$__module from "./discourse/routes/cakeday/birthdays/all";
export {
default as discourse$routes$cakeday$birthdays$all$$default
} from "./discourse/routes/cakeday/birthdays/all";
import * as Mod31 from "./discourse/routes/cakeday/birthdays/index";
compatModules["discourse/routes/cakeday/birthdays/index"] = Mod31;

export * as discourse$routes$cakeday$birthdays$index$$__module from "./discourse/routes/cakeday/birthdays/index";
export {
default as discourse$routes$cakeday$birthdays$index$$default
} from "./discourse/routes/cakeday/birthdays/index";
import * as Mod32 from "./discourse/routes/cakeday/birthdays/today";
compatModules["discourse/routes/cakeday/birthdays/today"] = Mod32;

export * as discourse$routes$cakeday$birthdays$today$$__module from "./discourse/routes/cakeday/birthdays/today";
export {
default as discourse$routes$cakeday$birthdays$today$$default
} from "./discourse/routes/cakeday/birthdays/today";
import * as Mod33 from "./discourse/routes/cakeday/birthdays/tomorrow";
compatModules["discourse/routes/cakeday/birthdays/tomorrow"] = Mod33;

export * as discourse$routes$cakeday$birthdays$tomorrow$$__module from "./discourse/routes/cakeday/birthdays/tomorrow";
export {
default as discourse$routes$cakeday$birthdays$tomorrow$$default
} from "./discourse/routes/cakeday/birthdays/tomorrow";
import * as Mod34 from "./discourse/routes/cakeday/birthdays/upcoming";
compatModules["discourse/routes/cakeday/birthdays/upcoming"] = Mod34;

export * as discourse$routes$cakeday$birthdays$upcoming$$__module from "./discourse/routes/cakeday/birthdays/upcoming";
export {
default as discourse$routes$cakeday$birthdays$upcoming$$default
} from "./discourse/routes/cakeday/birthdays/upcoming";
import * as Mod35 from "./discourse/templates/cakeday";
compatModules["discourse/templates/cakeday"] = Mod35;

export * as discourse$templates$cakeday$$__module from "./discourse/templates/cakeday";
export {
default as discourse$templates$cakeday$$default
} from "./discourse/templates/cakeday";
import * as Mod36 from "./discourse/templates/cakeday/anniversaries";
compatModules["discourse/templates/cakeday/anniversaries"] = Mod36;

export * as discourse$templates$cakeday$anniversaries$$__module from "./discourse/templates/cakeday/anniversaries";
export {
default as discourse$templates$cakeday$anniversaries$$default
} from "./discourse/templates/cakeday/anniversaries";
import * as Mod37 from "./discourse/templates/cakeday/anniversaries/all";
compatModules["discourse/templates/cakeday/anniversaries/all"] = Mod37;

export * as discourse$templates$cakeday$anniversaries$all$$__module from "./discourse/templates/cakeday/anniversaries/all";
export {
default as discourse$templates$cakeday$anniversaries$all$$default
} from "./discourse/templates/cakeday/anniversaries/all";
import * as Mod38 from "./discourse/templates/cakeday/anniversaries/today";
compatModules["discourse/templates/cakeday/anniversaries/today"] = Mod38;

export * as discourse$templates$cakeday$anniversaries$today$$__module from "./discourse/templates/cakeday/anniversaries/today";
export {
default as discourse$templates$cakeday$anniversaries$today$$default
} from "./discourse/templates/cakeday/anniversaries/today";
import * as Mod39 from "./discourse/templates/cakeday/anniversaries/tomorrow";
compatModules["discourse/templates/cakeday/anniversaries/tomorrow"] = Mod39;

export * as discourse$templates$cakeday$anniversaries$tomorrow$$__module from "./discourse/templates/cakeday/anniversaries/tomorrow";
export {
default as discourse$templates$cakeday$anniversaries$tomorrow$$default
} from "./discourse/templates/cakeday/anniversaries/tomorrow";
import * as Mod40 from "./discourse/templates/cakeday/anniversaries/upcoming";
compatModules["discourse/templates/cakeday/anniversaries/upcoming"] = Mod40;

export * as discourse$templates$cakeday$anniversaries$upcoming$$__module from "./discourse/templates/cakeday/anniversaries/upcoming";
export {
default as discourse$templates$cakeday$anniversaries$upcoming$$default
} from "./discourse/templates/cakeday/anniversaries/upcoming";
import * as Mod41 from "./discourse/templates/cakeday/birthdays";
compatModules["discourse/templates/cakeday/birthdays"] = Mod41;

export * as discourse$templates$cakeday$birthdays$$__module from "./discourse/templates/cakeday/birthdays";
export {
default as discourse$templates$cakeday$birthdays$$default
} from "./discourse/templates/cakeday/birthdays";
import * as Mod42 from "./discourse/templates/cakeday/birthdays/all";
compatModules["discourse/templates/cakeday/birthdays/all"] = Mod42;

export * as discourse$templates$cakeday$birthdays$all$$__module from "./discourse/templates/cakeday/birthdays/all";
export {
default as discourse$templates$cakeday$birthdays$all$$default
} from "./discourse/templates/cakeday/birthdays/all";
import * as Mod43 from "./discourse/templates/cakeday/birthdays/today";
compatModules["discourse/templates/cakeday/birthdays/today"] = Mod43;

export * as discourse$templates$cakeday$birthdays$today$$__module from "./discourse/templates/cakeday/birthdays/today";
export {
default as discourse$templates$cakeday$birthdays$today$$default
} from "./discourse/templates/cakeday/birthdays/today";
import * as Mod44 from "./discourse/templates/cakeday/birthdays/tomorrow";
compatModules["discourse/templates/cakeday/birthdays/tomorrow"] = Mod44;

export * as discourse$templates$cakeday$birthdays$tomorrow$$__module from "./discourse/templates/cakeday/birthdays/tomorrow";
export {
default as discourse$templates$cakeday$birthdays$tomorrow$$default
} from "./discourse/templates/cakeday/birthdays/tomorrow";
import * as Mod45 from "./discourse/templates/cakeday/birthdays/upcoming";
compatModules["discourse/templates/cakeday/birthdays/upcoming"] = Mod45;

export * as discourse$templates$cakeday$birthdays$upcoming$$__module from "./discourse/templates/cakeday/birthdays/upcoming";
export {
default as discourse$templates$cakeday$birthdays$upcoming$$default
} from "./discourse/templates/cakeday/birthdays/upcoming";
export default compatModules;
